import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    linkActiveClass:"active",
    linkExactActiveClass:"exact-active",
    routes: [
        {
            name: 'home',
            path: '/',
            component: () => import('./../views/home.vue'),
        },
        {   // 通用页面
          name: 'commonPage',
          path: '/commonPage',
          component: () => import('./../views/commonPage.vue')
        },
        {   // 算法详情
          name: 'detect-details',
          path: '/detect-details',
          component: () => import('./../views/detect-details.vue')
        },
    ]
})